import tarsUtil from '@alife/cn-tars-util';
export default (storageKeyTail = '') => {
    const habitKey = storageKeyTail
        ? `cn_one_search_habit_${storageKeyTail}`
        : 'cn_one_search_habit';
    const useTars = typeof window.__tars_config__ === 'object' && window.__tars_config__;
    const get = async () => {
        if (!useTars) {
            try {
                const res = localStorage.getItem(habitKey);
                if (res) {
                    return JSON.parse(res);
                }
                return {};
            }
            catch {
                return {};
            }
        }
        try {
            const resNext = await tarsUtil.ajax({
                url: '/api/open/habit/listActions',
                method: 'GET',
                data: { habitKey },
                skipValidate: true,
            });
            const { index: actionId, data: habitData = {} } = resNext?.data?.[0] || {};
            return {
                actionId,
                habitData,
            };
        }
        catch (e) {
            return {};
        }
    };
    const update = (actionId, habitData, _actionOption) => {
        if (!useTars) {
            try {
                localStorage.setItem(habitKey, JSON.stringify({
                    actionId,
                    habitData,
                }));
                if (_actionOption) {
                    console.log(_actionOption);
                }
                return Promise.resolve({
                    success: true,
                });
            }
            catch {
                return Promise.reject(new Error('update habit data failed, please try again later'));
            }
        }
        return tarsUtil.ajax({
            url: '/api/open/habit/updateAction',
            method: 'POST',
            data: {
                habitKey,
                actionId,
                newAction: JSON.stringify(habitData),
            },
            skipValidate: true,
        });
    };
    const add = async (habitData) => {
        if (!useTars) {
            try {
                localStorage.setItem(habitKey, JSON.stringify({
                    actionId: new Date().getTime(),
                    habitData,
                }));
                return Promise.resolve({
                    success: true,
                });
            }
            catch {
                return Promise.reject(new Error('add habit data failed, please try again later'));
            }
        }
        return tarsUtil.ajax({
            url: '/api/open/habit/addAction',
            method: 'POST',
            data: {
                habitKey,
                action: JSON.stringify(habitData),
            },
            skipValidate: true,
        });
    };
    return {
        get,
        update,
        add,
    };
};
